<template>
  <div class="zoom">
    <div class="slide photo2" ref="photo2" v-parallax-fit="photo2"></div>
    <div class="slide photo1" ref="photo1" v-parallax-fit="photo1"></div>
  </div>
</template>

<script>
export default {
  name: 'slide21_1',
  data() {
    return {
      photo1: [
        {
          start: 24700,
          end: 25300,
          fromStyle: { transform: 'translateY(-1200px)  rotateZ(0deg)' },
          toStyle: { transform: 'translateY(0px) rotateZ(0deg)' },
          easing: 'linear'
        },
        {
          start: 27300,
          end: 27900,
          fromStyle: { transform: 'translateY(0px)  rotateZ(0deg)' },
          toStyle: { transform: 'translateY(1900px) rotateZ(0deg)' },
          easing: 'linear'
        },
      ],
      photo2: [
        {
          start: 24900,
          end: 25500,
          fromStyle: { transform: 'translateY(-1200px)  rotateZ(0deg)' },
          toStyle: { transform: 'translateY(0px) rotateZ(0deg)' },
          easing: 'linear'
        },
        {
          start: 27500,
          end: 28000,
          fromStyle: { transform: 'translateY(0px)  rotateZ(0deg)' },
          toStyle: { transform: 'translateY(1900px) rotateZ(0deg)' },
          easing: 'linear'
        }
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.photo1 {
  position: absolute;
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/21_Photo_1.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 570px;
  height: 600px;
  left: -292px;
  top: calc(50% - 170px);
  transition: 0.6s;
  z-index: 4;
  @media(max-width: 600px) {
    width: 190px;
    height: 240px;
    left: -102px;
  }
  @media(max-width: 400px) {
    top: calc(50% - 100px);
  }
}
.photo2 {
  position: absolute;
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/21_Photo_3.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 470px;
  height: 540px;
  left: -240px;
  top: calc(50% - 350px);
  transition: 0.6s;
  z-index: 5;
  @media(max-width: 600px) {
    width: 190px;
    height: 340px;
    left: -100px;
  }
	@media(max-width: 400px) {
		top: calc(50% - 70px);
	}
}
</style>
